const memoryStore = new Map();
const COOKIE_MAX_AGE_SECONDS = 30 * 24 * 60 * 60;

function getStorage(type) {
  if (typeof window === 'undefined') return null;
  try {
    const storage = window[type];
    const testKey = '__creator_portal_storage_test__';
    storage.setItem(testKey, '1');
    storage.removeItem(testKey);
    return storage;
  } catch {
    return null;
  }
}

function getCookieValue(key) {
  if (typeof document === 'undefined') return null;
  const prefix = `${encodeURIComponent(key)}=`;
  const match = document.cookie
    .split(';')
    .map(cookie => cookie.trim())
    .find(cookie => cookie.startsWith(prefix));
  if (!match) return null;

  try {
    return decodeURIComponent(match.slice(prefix.length));
  } catch {
    return null;
  }
}

function setCookieValue(key, value) {
  if (typeof document === 'undefined') return;
  const secure = window.location.protocol === 'https:' ? '; Secure' : '';
  document.cookie = `${encodeURIComponent(key)}=${encodeURIComponent(value)}; Path=/; Max-Age=${COOKIE_MAX_AGE_SECONDS}; SameSite=Lax${secure}`;
}

function removeCookieValue(key) {
  if (typeof document === 'undefined') return;
  const secure = window.location.protocol === 'https:' ? '; Secure' : '';
  document.cookie = `${encodeURIComponent(key)}=; Path=/; Max-Age=0; SameSite=Lax${secure}`;
}

function getValue(type, key) {
  const storage = getStorage(type);
  if (storage) {
    try {
      return storage.getItem(key);
    } catch {
      return memoryStore.get(key) || null;
    }
  }
  return memoryStore.get(key) || null;
}

function getFirstValue(key) {
  return getValue('localStorage', key) || getValue('sessionStorage', key) || getCookieValue(key);
}

function setValue(type, key, value) {
  memoryStore.set(key, value);
  const storage = getStorage(type);
  if (storage) {
    try {
      storage.setItem(key, value);
    } catch {
      // Safari private mode and strict storage settings can reject writes.
    }
  }
}

function setAllValue(key, value) {
  memoryStore.set(key, value);
  setValue('localStorage', key, value);
  setValue('sessionStorage', key, value);
  setCookieValue(key, value);
}

function removeValue(type, key) {
  memoryStore.delete(key);
  const storage = getStorage(type);
  if (storage) {
    try {
      storage.removeItem(key);
    } catch {
      // Nothing else to clear when browser storage is unavailable.
    }
  }
}

function removeAllValue(key) {
  memoryStore.delete(key);
  removeValue('localStorage', key);
  removeValue('sessionStorage', key);
  removeCookieValue(key);
}

export const CREATOR_TOKEN_KEY = 'creator_token';
export const CREATOR_ONBOARDING_TOKEN_KEY = 'creator_onboarding_token';
export const TWITTER_OAUTH_STARTED_AT_KEY = 'creator_twitter_oauth_started_at';

export const getCreatorToken = () => getFirstValue(CREATOR_TOKEN_KEY);
export const setCreatorToken = (token) => {
  removeCreatorOnboardingToken();
  setAllValue(CREATOR_TOKEN_KEY, token);
};
export const removeCreatorToken = () => removeAllValue(CREATOR_TOKEN_KEY);

export const getCreatorOnboardingToken = () => getFirstValue(CREATOR_ONBOARDING_TOKEN_KEY);
export const setCreatorOnboardingToken = (token) => {
  removeCreatorToken();
  setAllValue(CREATOR_ONBOARDING_TOKEN_KEY, token);
};
export const removeCreatorOnboardingToken = () => removeAllValue(CREATOR_ONBOARDING_TOKEN_KEY);

export const getOAuthStartedAt = () => Number(getValue('sessionStorage', TWITTER_OAUTH_STARTED_AT_KEY) || 0);
export const setOAuthStartedAt = (timestamp) => setValue('sessionStorage', TWITTER_OAUTH_STARTED_AT_KEY, String(timestamp));
export const removeOAuthStartedAt = () => removeValue('sessionStorage', TWITTER_OAUTH_STARTED_AT_KEY);
